import { all, fork } from 'redux-saga/effects'

import getAllSaga from './getAllSaga'
import deleteSaga from './deleteSaga'
import repeatDaySaga from './repeatDaySaga'
import orderSaga from './orderSaga'
import postSaga from './postSaga'
import patchSaga from './patchSaga'

export default function* orgInactiveNotificationsSaga() {
  yield all([fork(getAllSaga), fork(deleteSaga), fork(repeatDaySaga), fork(orderSaga), fork(postSaga), fork(patchSaga)])
}
